module.exports = __webpack_public_path__ + "static/media/npm.0cfd04ae.png";